import { SITE, KIDDEE } from "@/config/sections";
import { HOME } from "@/constants/testIds";
import { ClipPlayer } from "@/components/ClipPlayer";

export const MeetKiddee = () => (
  <section data-testid={HOME.kiddee} className="max-w-7xl mx-auto px-6 lg:px-10 mt-24 grid lg:grid-cols-12 gap-10 items-center">
    <div className="lg:col-span-5 fade-up">
      <h2 className="font-heading text-base md:text-lg font-semibold uppercase tracking-[0.2em] text-[#4E7B68]">The tester</h2>
      <p className="font-heading mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight">Meet Kiddee.</p>
      {KIDDEE.story.map((p) => (
        <p key={p.slice(0, 20)} className="mt-6 text-stone-600 leading-relaxed">{p}</p>
      ))}
      <p className="mt-8 text-sm font-medium text-stone-500">Follow her adventures</p>
      <div className="mt-3 flex flex-wrap gap-3">
        {SITE.socials.map((s) => (
          <a
            key={s.id}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={HOME.kiddeeSocial(s.id)}
            className="px-5 py-2.5 rounded-full border border-[#1C1917] text-sm font-medium hover:bg-[#1C1917] hover:text-white transition-colors"
          >
            {s.label}
          </a>
        ))}
      </div>
    </div>
    <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-4 gap-4 fade-up" style={{ animationDelay: "120ms" }}>
      <ClipPlayer />
      {KIDDEE.photos.map((src, i) => (
        <img key={src} src={src} alt="Kiddee the rat terrier" loading="lazy" data-testid={HOME.kiddeePhoto(i)} className="w-full aspect-square object-cover rounded-3xl" />
      ))}
    </div>
  </section>
);
